import AKLSummitVis from './modules/aklsummit-vis';
import FocusOutlineDetect from './modules/focus-outline-detect';
import branchBar from './modules/branch-bar';


const init = () => {
  new FocusOutlineDetect().init();
  branchBar.init();

  if(window.AKLSplanets && window.AKLSdetails && window.cruxData) {
    const vis = new AKLSummitVis(window.AKLSplanets, window.AKLSdetails, window.cruxData);
    const parent = document.getElementById('aklsummit-vis');
    if(parent) vis.attach(parent);
  }
};

switch (document.readyState) {
  case 'loading':
    addEventListener('DOMContentLoaded', () => init());
    break;
  default:
    init();
}

console.log(`



▄████▄   ██▀███   ▄▄▄         ██████   ███▄ ▄███▓  ▄▄▄       ███▄    █
▒██▀ ▀█  ▓██ ▒ ██▒▒████▄     ▒██    ▒  ▓██▒▀█▀ ██▒ ▒████▄     ██ ▀█   █
▒▓█    ▄ ▓██ ░▄█ ▒▒██  ▀█▄   ░ ▓██▄    ▓██    ▓██░ ▒██  ▀█▄  ▓██  ▀█ ██▒
▒▓▓▄ ▄██▒▒██▀▀█▄  ░██▄▄▄▄██    ▒   ██▒ ▒██    ▒██  ░██▄▄▄▄██ ▓██▒  ▐▌██▒
▒ ▓███▀ ░░██▓ ▒██▒ ▓█   ▓██▒ ▒██████▒▒ ▒██▒   ░██▒  ▓█   ▓██▒▒██░   ▓██░
░ ░▒ ▒  ░░ ▒▓ ░▒▓░ ▒▒   ▓▒█░ ▒ ▒▓▒ ▒ ░░ ▒░   ░  ░ ▒ ▒   ▓▒█░░ ▒░   ▒ ▒
  ░  ▒     ░▒ ░ ▒░  ▒   ▒▒ ░ ░ ░▒  ░ ░░  ░      ░   ▒   ▒▒ ░░ ░░   ░ ▒░
░          ░░   ░   ░   ▒    ░  ░  ░  ░      ░      ░   ▒      ░   ░ ░
░ ░         ░           ░  ░      ░         ░         ░  ░         ░
░
`)
